export default __webpack_public_path__ + "static/media/1.a676e1e5.jpg";